var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',{attrs:{"shrink":""}},[_c('v-text-field',{attrs:{"solo":"","hide-details":"","prepend-inner-icon":"mdi-magnify","placeholder":"Search","clearable":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }